import React from "react";

export const ImageComponent = ({ images }: { images: string[][] }) => (
  <picture className="swiper-lazy">
    <source
      srcSet={images.map((img: string[]) => img.join(" ")).join(", ")}
      sizes="(max-width: 1000px) 70vw"
      media="(min-width: 768px)"
    />

    <img
      src={images[0][0]}
      alt="carousel images"
      width="100%"
      height="100%"
      style={{ objectFit: "cover" }}
    />
  </picture>
);
